import { Component, Input } from '@angular/core';
import { MetadatiService } from 'src/app/amministrazione/components/metadati/metadati/service/metadati.service';
import { Metadata, MetadataExt } from 'src/app/common/models/metadati/metadata';
import { ItemOrder } from 'src/app/lem/models/common/item-order';

@Component({
  selector: 'app-metadata-add',
  templateUrl: './metadata-add.component.html',
  styleUrls: ['./metadata-add.component.css']
})
export class MetadataAddComponent {


  @Input() tipoPratica : string;

  metadataAssociated: ItemOrder<Metadata>[];

  metadata: Metadata[];

  metadataSelected: MetadataExt[] = [];

  constructor(private metadatiService: MetadatiService){}

  ngOnInit(){
    this.metadatiService.findAllByPracticeType(this.tipoPratica)
                              .subscribe((response) => {
                              this.metadataAssociated = response && response.length > 0 ? response.sort((a, b) => a.order - b.order) : [];
                              console.log(this.metadataAssociated[0].item);
                              this.metadata = this.metadataAssociated.map(value => value.item);
                              console.log(this.metadata)
                            });
  }

  selectedMetadato(value: MetadataExt){
    this.metadataSelected.push(value);
  }

}
